<aside class="s__callout-block"
       [attr.aria-label]="label() || null"
       [attr.aria-labelledby]="!label() && heading() ? headingId : null"
       [style.--callout-accent]="getBorderColor()"
       [class.s__callout-block--with-image]="!!imageSrc()">
  @if (imageSrc()) {
    <img class="s__callout-block__image"
         [ngSrc]="imageSrc()"
         [width]="imageWidth() || 1600"
         [height]="imageHeight() || 900"
         [alt]="imageAlt()" />
  }
  <div class="s__callout-block__content">
    @if (heading()) {
      <div class="s__callout-block__heading" [id]="headingId" [innerHTML]="heading()"></div>
    }
    <div class="s__callout-block__body">
      @if (body()) {
        <div [innerHTML]="body()"></div>
      }
    </div>
  </div>
</aside>
